<template>
  <b-row class="base-row-padded">
    <b-col>
      <b-row>
        <b-col>
          <b-button variant="light" :to="{name: 'logs'}"> &lt; Back to Logs</b-button>
          <h2>Log info</h2>
        </b-col>
      </b-row>
      <b-row v-if="logObject">
        <b-col cols="12">
          <small>{{parseDate(logObject.created_at)}}</small>
          <h4>{{logObject.log_name}}</h4>
        </b-col>
        <b-col cols="12">
          <small>Subject id: {{logObject.subject_id}}</small>
          <p>{{logObject.description}}</p>
        </b-col>
        <b-col cols="12" md="6" v-if="logObject.properties && logObject.properties.old">
          <b-card no-body header="Previous data">
            <b-list-group flush>
              <b-list-group-item v-for="(item, index) in flattenProps(logObject.properties.old)" :key="index">
                <small>{{item.name}}</small>
                <div>{{item.value}}</div>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-col>
        <b-col cols="12" md="6" v-if="logObject.properties && logObject.properties.attributes">
          <b-card no-body header="New data">
            <b-list-group flush>
              <b-list-group-item v-for="(item, index) in flattenProps(logObject.properties.attributes)" :key="index">
                <small>{{item.name}}</small>
                <div>{{item.value}}</div>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import axios from '@/modules/axiosInterceptor';
import { apiUrlPrefix } from '@/modules/staticData';
import datetime from '@/mixins/datetime';

export default {
  mixins: [datetime],
  data() {
    return {
      logObject: null,
    };
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  created() {
    this.fetchLog();
  },
  methods: {
    fetchLog() {
      axios.get(`${apiUrlPrefix}logs/${this.id}`).then((r) => {
        this.logObject = r.data.log;
      }).catch(() => {});
    },
  },
  computed: {
    flattenProps() {
      return (target) => {
        const propArray = [];
        Object.keys(target).forEach((key) => {
          propArray.push({
            name: key,
            value: JSON.stringify(target[key]),
          });
        });
        return propArray;
      };
    },
  },
};
</script>
